import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Glyphicon, Row, Button } from 'react-bootstrap';

var getLang = function () {
  var l = localStorage.getItem('stuLang');
  return l ? l : 'en';
};

var t = function (enText, esText) {
  var lang = getLang();
  return lang === 'es' ? esText : enText;
};

class Navbar extends React.Component {

    renderSectionSubtitle() {
        let { title = '', activeSectionPagesList = [], pageNum, pageCount } = this.props;

        if (Array.isArray(activeSectionPagesList) && activeSectionPagesList[0]) {
            const firstActiveSectionItemTitle = activeSectionPagesList[0].title.toLowerCase();

            if (firstActiveSectionItemTitle === 'intro') {
                title = t('Module Guide', 'Guía del Módulo');
            } else if (firstActiveSectionItemTitle.includes('rca')) {
                title = 'RCA'; // same in Spanish
            } else if (firstActiveSectionItemTitle === 'credits') {
                title = t('Knowledge Survey', 'Encuesta de Conocimientos');
            } else if (firstActiveSectionItemTitle.includes('test')) {
                title = firstActiveSectionItemTitle;
            } else if (firstActiveSectionItemTitle.includes('resume builder')) {
                title = '';
            } else {
                title = t('Enrichment', 'Enriquecimiento');
            }
        }

        if (pageNum < 2) {
            return (
                <div className="viewer-navbar-title viewer-navbar-title-first-page pull-left">
                    {title}
                </div>
            );
        } else {
            if (pageNum > 1) {
                pageNum = pageNum - 1;
                pageCount = pageCount - 1;
            }
            return (
                <div className="viewer-navbar-title pull-left">
                    {t('Page', 'Página')} {pageNum} {t('of', 'de')} {pageCount}
                </div>
            );
        }
    }

    render() {
        const { title = '', titleLink = '/', sectionTitle, exitViewer, submitting } = this.props;

        return (
            <Row className="navbar viewer-navbar">
                <div className="viewer-navbar-title pull-left">
                    {submitting ?
                        <a className="dialogTitleSmallFullScr">{title}</a> :
                        <span className="dialogTitleSmallFullScr">{title}</span>
                    }
                </div>

                <div className="viewer-navbar-title pull-left">
                    {sectionTitle}
                </div>

                {this.renderSectionSubtitle()}

                <div className="pull-right">
                    <Button onClick={exitViewer} className="jre-close-btn" disabled={submitting}>
                        <Glyphicon glyph="remove" className="cursor-pointer jre-close" />
                    </Button>
                </div>
            </Row>
        );
    }
}

Navbar.propTypes = {
    title: PropTypes.string,
    titleLink: PropTypes.string
};

export default connect(
    null,
    null,
)(Navbar);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/page/navbar.js